import { Outlet, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import Chatbot from './Chatbot';

/* Dominio de producción: el canonical debe apuntar siempre a la web
 * pública, no a localhost ni a una URL de preview. */
const SITE_URL = 'https://www.brundingestion.com';

function Layout() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [location.pathname]);

  /* Al ser una SPA, el <head> de index.html es el mismo en todas las
   * rutas: el canonical fijo hacía que /locales, /contacto y /faqs se
   * declarasen duplicados de la portada, o sea, que Google no las
   * indexara. Aquí se actualiza en cada navegación. */
  useEffect(() => {
    const { pathname } = location;
    // Se normaliza la barra final para no generar dos URLs por página
    const path = pathname !== '/' && pathname.endsWith('/')
      ? pathname.slice(0, -1)
      : pathname;

    let link = document.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement('link');
      link.setAttribute('rel', 'canonical');
      document.head.appendChild(link);
    }
    link.setAttribute('href', `${SITE_URL}${path}`);
  }, [location]);

  return (
    <div className="app">
      <Navbar />
      <main>
        <Outlet />
      </main>
      <Footer />
      <Chatbot />
    </div>
  );
}

export default Layout;
